import type {
  BulletinResponse,
  BulletinSimpleResponse,
} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';
import type {IFormFieldV2} from 'src/types/FormV2';
import {contentPdfField} from 'src/app/content-pdf/contentPdf';

export const BulletinFormMeta = (): IFormFieldV2[] => [
  {
    name: 'title',
    label: 'Title',
    type: 'text',
    required: true,
    description:
      'The title of the bulletin. This is shown in list views and in the title of the bulletin.',
    validation: {
      maxLength: 500,
    },
    textboxOptions: {
      validationType: 'safe',
    },
  },
  {
    name: 'active',
    label: 'Active',
    type: 'switch',
    description:
      'Enable or disable the bulletin. If enabled, all other bulletins are disabled so that this bulletin becomes the only active bulletin.',
  },
  {
    name: 'content',
    label: 'Text',
    type: 'richtext',
    required: false,
    description: 'Optional. Add text, a PDF, or both.',
  },
  contentPdfField,
];

export const CreateDefaultBulletin = (): BulletinResponse => {
  return {
    title: '',
    active: true,
    content: '',
  } as BulletinResponse;
};

export const GetBulletinPillConfig = (
  data?: BulletinResponse | BulletinSimpleResponse
): PillProps[] => {
  const pills: PillProps[] = [];
  if (data?.active === true) {
    pills.push({text: 'Active', color: 'green'});
  } else if (data?.active === false) {
    pills.push({text: 'Inactive', color: 'yellow'});
  }

  return pills;
};

export const BulletinDocumentTitle = 'Bulletins';
